import { render, staticRenderFns } from "./ChatEstrelaIcon.vue?vue&type=template&id=1d9d76ee&scoped=true"
import script from "./ChatEstrelaIcon.vue?vue&type=script&lang=js"
export * from "./ChatEstrelaIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatEstrelaIcon.vue?vue&type=style&index=0&id=1d9d76ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d76ee",
  null
  
)

export default component.exports